<template>
  <div class="tuolele-main-box company-add">
    <el-form ref="form" :model="accountInfo" label-width="140px">
      <el-form-item label="公司名称" required>
        <el-input
          v-model="accountInfo.username"
          clearable
          placeholder="请输入公司名称，如：文启优思"
        />
      </el-form-item>
      <el-form-item label="公司简称" required>
        <el-input
          v-model="accountInfo.nickname"
          clearable
          placeholder="请输入公司简称，如：文启"
        />
      </el-form-item>
      <el-form-item label="描述">
        <el-input
          v-model="accountInfo.nickname"
          clearable
          placeholder="上海唯一品牌"
        />
      </el-form-item>
      <el-form-item label="管理员账号名" required>
        <el-input
          v-model="accountInfo.nickname"
          clearable
          placeholder="请输入管理员账号名，如wqyousi"
        />
      </el-form-item>
      <el-form-item label="选择分组" required>
        <el-select
          v-model="accountInfo.obligation_id"
          placeholder="请选择公司分组"
        >
          <el-option
            v-for="(item, index) in obligationList"
            :key="index"
            :label="item.title"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="公司主体" required>
        <el-input
          v-model="accountInfo.nickname"
          clearable
          placeholder="请输入公司主体，如：上海剑优教育科技有限公司"
        />
      </el-form-item>
      <el-form-item class="form-buttom">
        <el-button
          type="primary"
          class="el-button-confirm"
          @click="accountImprove"
        >保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'CompanyAdd',
  data() {
    return {
      type: 'add',
      accountInfo: {
        shop_id: '',
        nickname: '',
        username: '',
        obligation_id: '',
        synchro_status: '',
        password: ''
      },
      shopList: [],
      selectSchool: [],
      obligationList: []
    }
  },
  mounted() {
    this.type = this.$route.query.type
    this.accountInfo.uid = this.$route.query.uid
    if (this.accountInfo.uid) {
      this.getAccountInfo()
    }
  },
  methods: {
    getAccountInfo() {
      this.$http.getAccountInfo({ uid: this.accountInfo.uid }).then(res => {
        this.accountInfo = res.data
        this.selectSchool = this.accountInfo.shop_id.split(',')
      })
    },
    accountImprove() {
      if (
        !this.accountInfo.shop_id ||
        !this.accountInfo.nickname ||
        !this.accountInfo.username ||
        !this.accountInfo.obligation_id ||
        !this.accountInfo.synchro_status
      ) {
        this.$message({
          type: 'info',
          message: '请完善公司信息'
        })
        return
      }
      if (this.type == 'add' && !this.accountInfo.password) {
        this.$message({
          type: 'info',
          message: '请填写账号初始密码'
        })
        return
      }
      this.$http.improveAccount(this.accountInfo).then(res => {
        if (res.code == 200) {
          this.$message({
            type: 'success',
            message: '操作成功'
          })
          this.$router.go(-1)
        }
      })
    }
  }
}
</script>
<style lang="scss">
.company-add {
  .el-input,
  .el-textarea {
    width: 310px;
  }
  .form-buttom {
    .el-form-item__content {
      margin-left: 140px !important;
    }
  }
  .checkbox-item:first-child {
    width: 80px !important;
    margin-bottom: 20px;
  }
  .checkbox-item {
    width: 160px !important;
    margin-bottom: 20px;
  }
}
</style>
